export default {
  en: {
    TestData: {
      input: 'I am just an input',
      p: 'I am just a paragraph',
    },
    BusinessProfile: 'Business Profile',
    Settings: 'Settings',
    Btn: {
      active: 'Active',
      activate: 'Activate',
      addCustomer: 'Add Customer',
      backHome: 'To Home',
      bookAppointment: 'Book Appointment',
      checkout: 'Checkout',
      customerInfo: 'Customer Info >>',
      confirm: 'Confirm >>',
      customerId: 'Customer ID',
      customerIndex: 'Customer Index',
      customerDetail: 'Customer Detail',
      clearForm: 'Clear Form',
      dateTime: 'Date / Time >>',
      deactivate: 'Deactivate',
      email: 'Email',
      firstName: 'First Name',
      goBack: 'Go Back',
      history: 'History',
      inactive: 'Inactive',
      login: 'Login',
      lastName: 'Last Name',
      newMenu: 'New Menu',
      password: 'Password',
      profile: 'Profile',
      reloadData: 'Reload Data',
      settings: 'Settings',
      signup: 'Signup',
      startOver: 'Start Over',
      update: 'Update',
      updateProfile: 'Update Profile',
      updateSettings: 'Update Settings',
      cancel: 'Cancel',
    },
    Currency: '$',
    DateTime: {
      hour: 'hour',
      min: 'min',
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sep: 'Sep',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dec',
      months: "'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'"
    },
    Locale: {
      locale: 'NY',
      tax: '(NY)'
    },
    Home: {
      greeting: 'Welcome to Booking App Biznesu',
      message: 'Please login/signup to book an appontment',
      loginAdmin: 'Login as Admin',
      loginUser: 'Login as User',
      email: 'Email',
      password: 'Password',
    },
    Login: {
      pageTitle: 'Login',
      loginAdmin: 'Login as Admin',
      loginUser: 'Login as User',
      form: {
        email: 'Email',
        password: 'Password',
      },
    },
    Appointments: {
      totalDuration: 'Total Duration',
      hour: 'hour',
      min: 'min',
      title: {
        pickMenu: 'Pick Menu',
        pickTime: 'Pick a Date and Time',
        customerInfo: 'CustomerInfo',
        confirmation: 'Confirmation',
      },
      steps: {
        menu: 'Menu',
        dateTime: 'Date / Time',
        customerInfo: 'Customer Info',
        confirmation: 'Confirmation',
      },
      errors: {
        selectMenus: 'Please pick at least one menu.',
        selectDateTime: 'Please pick a date and a time.',
      }
    },
    Complete: {
      thankYou: "Thank You!",
      linkNotice: "Clink on the link below to see your appointment on the calendar in the admin page. (Admin only)",
      bookedNotice: "We just made your appointment.",
      rescheduleNotice: "If you wish to reschedule/cancel your appintment, please give us a call.",
      cancelationNotice: "Please note that we might charge cancelation fee for appointments start within 24 hours.",
      anyCountry: 'Any Country',
    },
    Calendar: {
      dontSeeAppointments: "Don't see appointments?",
    },
    Dashboard: {
      appointmentsByMenu: 'Appointments by Menu',
      salesByMenu: 'Sales by Menu ($)',
      Charts: {
        appointments: 'Appointments',
        sales: 'Sales',
        thisYear: 'This Year',
        prevYear: 'Prev Year',
        users: 'Users',
        avarageSpent: 'Avarage Spent',
      }
    },
    Spinner: {
      createAppointment: 'Createing your appointment',
      createAndLogin: 'Creating your account and logging in...',
      loading: 'Loading',
      loggingIn: 'Logging in',
      collectingData: 'Collecting Data',
    },
    Forms: {
      name: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      gender: 'Gender',
      zip: 'Zip Code',
      state: 'State',
      city: 'City',
      address: 'Address',
      requestsAndNote: 'Requests/Note',
      note: 'Note',
      appointmentDate: 'Appointment Date',
      time: 'Time',
      subtotal: 'Subtotal',
      tax: 'Tax',
      total: 'TOTAL',
      title: 'Title',
      price: 'Price',
      duration: 'Duration',
      description: 'Description',
      country: 'Country',
      cardNumber: 'Card No',
      exp: 'Exp',
      cvc: 'CVC',
      businessName: 'Business Name',
      website: 'Website URL',
      instagram: 'Instagram URL',
      twitter: 'Twitter URL',
      facebook: 'Facebook URL',
      language: 'Language',
      taxRate: 'Tax Rate',
      calendarStartTime: 'Calendar Start Time',
      calendarEndTime: 'Calendar End Time',
      intervalTime: 'Interval Time (min)'
    },
    Messages: {
      couponNotice: 'Bring your coupon and plesent at the salon before the treatment starts.',
      priceNotice: 'Price may vary according to body condition.',
      tearmsAndCondition: 'Tearms and Condition',
      privacyPolicy: 'Privacy Policy',
      agree: 'Agree to our',
      and: 'and',
      tos: 'Term of Service',
      term: 'I accept xxx {0}.',
      testModeNotice: 'Use this test card to checkout.',
    },
    Menus: {
      menu: 'Menu',
      arms: 'Arms',
      VIO: 'VIO',
      legs: 'Legs',

    },
    Customers: {
      sortBy: 'Sort by',
      customerDetail: 'Customer Detail',
      history: 'History',
      clickToSee: 'Click to see customerdetails',
      statics: {
        totalAppointments: 'Total Appointments',
        totalSpent: 'Total Spent',
        lastVisit: 'Last Visit',

      }
    },
    Gender: {
      male: 'Male',
      female: 'Female',
      nonBinary: 'Non Binary',
      ratherNot: 'Rather not to descrive',
      NA: 'N/A',
    },
    StatesUS: {
      AL: 'AL',
      AK: 'AK',
      AZ: 'AZ',
      AR: 'AR',
      CA: 'CA',
      CO: 'CO',
      CT: 'CT',
      DE: 'DE',
      FL: 'FL',
      GA: 'GA',
      HI: 'HI',
      ID: 'ID',
      IL: 'IL',
      IN: 'IN',
      IA: 'IA',
      KS: 'KS',
      KY: 'KY',
      LA: 'LA',
      ME: 'ME',
      MD: 'MD',
      MA: 'MA',
      MI: 'MI',
      MN: 'MN',
      MS: 'MS',
      MO: 'MO',
      MT: 'MT',
      NE: 'NE',
      NV: 'NV',
      NH: 'NH',
      NJ: 'NJ',
      NM: 'NM',
      NY: 'NY',
      NC: 'NC',
      ND: 'ND',
      OH: 'OH',
      OK: 'OK',
      OR: 'OR',
      PA: 'PA',
      RI: 'RI',
      SC: 'SC',
      SD: 'SD',
      TN: 'TN',
      TX: 'TX',
      UT: 'UT',
      VT: 'VT',
      VA: 'VA',
      WA: 'WA',
      WV: 'WV',
      WI: 'WI',
      WY: 'WY'
    },
  }
}
